import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

export type TDeleteClipParams = {
  id: string;
};

export function deleteClip({ id }: TDeleteClipParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/clips/${id}`);
}

type MutationFn = typeof deleteClip;

type TUseDeleteClipParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteClip({ config }: TUseDeleteClipParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('El corte no existe');
      }
      addErrorNotification('No se ha podido eliminar el corte');
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['clips'],
        exact: false,
      });
      addSuccessNotification('El corte se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteClip,
  });
}
